module.exports = __webpack_public_path__ + "static/img-banner-46eb92761cc5000140129052aa917a72.png";